export const Option: {
    [key: string]: any
} = {
    9999: {
        subject: "全部"
    }
}
